// test248
(248 && 0);
